<script lang="ts">

    import EditDialogView from "../../../../../component/common/Dialog/EditDialogView.svelte";
    import {UrlUtil} from "../../../../../lib/Common/Http/UrlUtil";
    import {HttpRequestUtil} from "../../../../../lib/Common/Http/HttpRequestUtil";
    import {createEventDispatcher} from "svelte";
    import PortalView from "../../../../../component/common/Portal/PortalView.svelte";
    import InputAreaView from "../../../../../component/common/Form/InputAreaView.svelte";
    import {SpaceUserTable} from "../../../../../lib/Table/SpaceUserTable";

    const dispatcher = createEventDispatcher();

    export let editData;


    let isLoading = false;


    function close() {
        dispatcher('close');

    }

    function save() {


        const url = UrlUtil.createApiUrl("space_user");

        isLoading = true;
        HttpRequestUtil.postRequest(url, editData, (response) => {
            isLoading = false;

            console.log(response);
            const body = response['body'];

            dispatcher('update');
            close();

        });
    }


</script>

<PortalView>
    <EditDialogView editData={editData} on:save={save} on:cancel={close} title="スペースの個別権限編集"
                    on:close={close}
    >
        <div class="space-user-edit-dialog-content">
            <div>
                <InputAreaView label="メールアドレス">
                    <input required type="text" class="input-mail-address" placeholder="xxxx@bns-g.com"
                           bind:value={editData.user_email}
                    />
                </InputAreaView>

            </div>
            <div>
                <InputAreaView label="権限種別">
                    <select class="authority-type" bind:value={editData.authority_type}>
                        {#each Object.entries(SpaceUserTable.AuthorityType.map) as [id, name]}
                            {#if Number(id) !== SpaceUserTable.AuthorityType.Manage}
                                <option value={Number(id)}>
                                    {name}
                                </option>
                            {/if}
                        {/each}

                    </select>
                </InputAreaView>
            </div>


        </div>
    </EditDialogView>
</PortalView>

<style lang="scss">
    .space-user-edit-dialog-content {
        .input-mail-address {
            min-width: 32em;
        }
    }

</style>